import Vue from "vue";
// import Vue from 'vue/dist/vue.js';
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import IMask from "imask";
import moment from "moment";
import VueMoment from "vue-moment";
// const fb = require("./firebaseConfig.js");

import { instance } from "./global";
Vue.mixin(instance);

import { formatos } from "./_pdf";
Vue.mixin(formatos);

import { formatos_excel } from "./_excel";
Vue.mixin(formatos_excel);

require("moment/locale/es");
moment.locale("es");

Vue.use(VueMoment, { moment });

Vue.config.productionTip = false;

Vue.use(vuetify, {
  options: {
    customProperties: true,
  },
});

var app = new Vue({
  router,
  vuetify,
  IMask,
  moment,
  render: (h) => h(App),
}).$mount("#app");
